import { NgClass, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { SuccessIconComponent } from '../sonner-icons/success-icon.component';
import { InfoIconComponent } from '../sonner-icons/info-icon.component';
import { WarningIconComponent } from '../sonner-icons/warning-icon.component';
import { ErrorIconComponent } from '../sonner-icons/error-icon.component';

@Component({
  selector: 'app-custom-toast',
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    SuccessIconComponent,
    InfoIconComponent,
    WarningIconComponent,
    ErrorIconComponent,
  ],
  templateUrl: './custom-toast.component.html',
  styleUrl: './custom-toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomToastComponent implements OnInit {
  @Input() type: 'success' | 'info' | 'warning' | 'error' = 'info';
  @Input() title!: string;
  @Input() description!: string;
  @Input() duration: number = 3000; // Default duration: 5 seconds
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() action!: any;
  @Input() actionButtonStyle!: string;

  ngOnInit() {
    setTimeout(() => {
      this.closeToast();
    }, this.duration);
  }

  closeToast() {
    // Logic to remove the toast (e.g., emit an event to parent or use a service)
  }
}
